"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.TermsOfService = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _class;

var TermsOfService = (0, _mobxReact.observer)(_class =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(TermsOfService, _Component);

  function TermsOfService(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = TermsOfService.prototype;

  _proto.render = function render() {
    var siteTitle = this.props.siteName;
    return _react.default.createElement("ul", null, _react.default.createElement("li", null, siteTitle, " reserves the right to change these terms and conditions without notice by posting the changes to this site."), _react.default.createElement("li", null, "You have read our copyright notice and terms and conditions and you agree to them."), _react.default.createElement("li", null, "You agree to use ", siteTitle, " services at your own risk. Our information is provided as a free service and does not come with any warranties or continuation of service agreements. You agree not to hold us responsible for data loss or interruption of service of any kind."), _react.default.createElement("li", null, "You agree to determining the usefulness of the information found at", " ", siteTitle, " yourself and take all liability for acting upon any provided information."));
  };

  return TermsOfService;
}(_react.Component)) || _class;

exports.TermsOfService = TermsOfService;